import React from "react";
import { Helmet } from "react-helmet-async";

export default function PageSEO({
  title,
  description,
  path = "/",
  image = "/og.png",
  noindex = false,
  jsonLd
}) {
  const base = process.env.REACT_APP_SITE_URL || "";
  const url = `${base}${path}`;

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={url || path} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url || path} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}
